import Sidebar from './Sidebar';
import { GiPadlock } from "react-icons/gi";
import ExportSidebar from './ProSideBar';

const NoPrivileges = ({currentUser}) => {
    return (
        <>
        <Sidebar/>
        <div style={{display:'flex', flexDirection:'row', gap:'10px'}}>
            <ExportSidebar/>
            <div style={{display:'flex', flexDirection:'column', gap:'10px', justifyContent:'center',alignItems:'center',width:'100%'}}>
                <GiPadlock size={70}/>
                {currentUser.email} no tiene privilegios para visualizar esta página.
            </div>
        </div>
        </>
    )
}

export default NoPrivileges;
